export default interface ElementarySchoolTeachingAidOption {
  readonly id?: number;
  readonly regular?: boolean;
}

export const ElementarySchoolTeachingAidOptionInital: ElementarySchoolTeachingAidOption = {
  regular: false
};
